import React from "react";
import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ThemeToggle } from "./ui/ThemeToggle";
import { LanguageSelector } from "./ui/LanguageSelector";

export const ChatHeader = ({
  onClose,
  theme,
  onToggleTheme,
  showBranding = true,
  widgetConfig = null,
}) => {
  const { t } = useTranslation();

  const companyName = widgetConfig?.company_name || t("widget.title");
  const companyLogo = widgetConfig?.company_logo_base64;

  const logoSrc = companyLogo?.startsWith("data:")
    ? companyLogo
    : companyLogo
    ? `data:image/png;base64,${companyLogo}`
    : null;

  return (
    <div className="gpc-chat-header">
      <div className="gpc-header-content">
        {logoSrc && (
          <div className="gpc-header-logo">
            <img src={logoSrc} alt={companyName} className="gpc-company-logo" />
          </div>
        )}
        <div className="gpc-header-text">
          <h2 className="gpc-header-title">{companyName}</h2>
        </div>
      </div>

      <div className="gpc-header-actions">
        <LanguageSelector />
        <ThemeToggle theme={theme} onToggle={onToggleTheme} />

        <button
          onClick={onClose}
          className="gpc-header-button gpc-focus-visible gpc-transition"
          aria-label={t("chat.close")}
          title={t("chat.close")}
        >
          <ChevronDown className="gpc-icon" />
        </button>
      </div>
    </div>
  );
};